<template>
  <div class="audio-wrapper d-flex align-items-center justify-content-center">
    <audio ref="recordingPlayer" autoplay controls>
      <source :src="audioSrc">
    </audio>
  </div>
</template>

<script>
import Cti from '@/models/Cti'

export default {
  name: 'Window.Consultation.Recording.OneTouchFile',
  data () {
    return {
      audioSrc: ''
    }
  },
  async mounted () {
    const recordingFile = await Cti.showOneTouchRecordingFile({
      unique_id: typeof this.$route.query.unique_id !== 'undefined' ? this.$route.query.unique_id : '',
      src: typeof this.$route.query.src !== 'undefined' ? this.$route.query.src : '',
      dst: typeof this.$route.query.dst !== 'undefined' ? this.$route.query.dst : ''
    })

    this.audioSrc = recordingFile.data.path

    this.$refs.recordingPlayer.load()
    this.$refs.recordingPlayer.play()
  }
}
</script>

<style scoped lang="scss">
.audio-wrapper {
  height: 103px;
  padding: 0 15px;

  audio {
    border: 1px solid #eee;
    width: 100%;
    margin-top: 20px;
  }
}
</style>
